/* global VXConfig */
import FluxEventEmitter from '../FluxEventEmitter';
import assign from 'object-assign';
import { doFetch, urlWithQuery } from '../../utils/CommonUtils';
import Constants from '../Constants';

const SERVICE_URL = VXConfig.tagsServiceUrl;
const LANG = VXConfig.language;
const VXQL_ACCESS_TOKEN = VXConfig.vxqlAccessToken;

/**
 *
 * @param {string} query
 * @param {Object} variables
 * @param {Object} queryParam
 * @param {string} url
 * @returns {Promise}
 */
function doServiceRequest(query, variables = null, queryParam = {}, url) {
	const queryObject = {};
	queryObject.query = query;

	if (variables) {
		queryObject.variables = variables;
	}

	const init = {
		headers: { Authorization: 'Bearer ' + VXQL_ACCESS_TOKEN },
	};

	const requestUrl = urlWithQuery(url, {
		...queryParam,
		language: LANG,
	});

	return doFetch(requestUrl, queryObject, Constants.HttpMethods.POST, false, init);
}

/**
 *
 * @param {String} search
 * @param {Function} callback
 */
function searchTags(search, callback) {
	const query = `
	query SearchTags($search: String){
		tagSearch (search: $search){
			tags {
				id
				label
			}
		}
	}`;

	doServiceRequest(query, { search }, null, SERVICE_URL).then(callback);
}

const TagsStore = assign({}, FluxEventEmitter.prototype, {
	searchTags(search, callback) {
		searchTags(search, callback);
	},
});

export default TagsStore;
